import 'intersection-observer';
import 'picturefill';
import 'lazysizes';
import './modules/modernizr';
import Mark from 'mark.js';
import Swiper from 'swiper';
import 'core-js/es/number/is-nan';
import 'core-js/es/array/from';
import Vue from 'vue';
import VueScrollto from 'vue-scrollto';
import scrollama from 'scrollama';
Vue.use(VueScrollto);
window.addEventListener('DOMContentLoaded', () => {
    const myVue = new Vue({
        el: '#js-main',
        data: {
            isShowModal: false,
            isShowScrollTop: false,
            listType: 'ver7',
            listLatest: 'ver7',
            listOther: 'other',
            swiper: undefined,
            swiperIndex: 0,
            marker: undefined,
            searchNoMatch: false,
            charaList: [],
        },
        watch: {
            isShowModal() {
                if (this.isShowModal) {
                    // スライド機能の初期化
                    if (!myVue.$data.swiper) {
                        myVue.$data.swiper = new Swiper('.swiper-container');
                    }
                    this.$nextTick(() => {
                        myVue.$data.swiper.slideTo(this.swiperIndex, 0);
                        myVue.$data.swiper.update();
                    });
                }
            },
        },
        computed: {
            scrollTopButtonStyleClassName() {
                if (this.isShowScrollTop) {
                    return 'animate__bounceInUp';
                }
                return 'animate__bounceOutDown';
            },
            searchFormStyleClassName() {
                if (this.searchNoMatch) {
                    return 'is-error';
                }
                return '';
            },
        },
        methods: {
            handleClickVer7() {
                this.listType = 'ver7';
                this.charaList = charaList['ver7'];
                this.$nextTick(() => this.scrollTo(this.$refs.filter));
            },
            handleClickVer6() {
                this.listType = 'ver6';
                this.charaList = charaList['ver6'];
                this.$nextTick(() => this.scrollTo(this.$refs.filter));
            },
            handleClickVer5() {
                this.listType = 'ver5';
                this.charaList = charaList['ver5'];
                this.$nextTick(() => this.scrollTo(this.$refs.filter));
            },
            handleClickOther() {
                this.listType = this.listOther;
                this.$nextTick(() => this.scrollTo(this.$refs.filter));
            },
            handleClickPickUpChara(evt) {
                this.isShowModal = true;
                if (evt.target === null) {
                    return;
                }
                const el = evt.target;
                if (el.dataset.index) {
                    this.swiperIndex = Number(el.dataset.index);
                }
            },
            handleClickModalClose() {
                this.isShowModal = false;
            },
            handleClickSearch() {
                this.searchWords();
            },
            // トップへ戻る
            handleClickScrollTop() {
                this.scrollTo(this.$refs.header);
            },
            // 検索のエンター
            handleEnterSearch() {
                this.searchWords();
            },
            handleSearchKeydown() { },
            scrollTo(el) {
                if (!el) {
                    return;
                }
                el = el;
                this.$scrollTo(el);
            },
            searchWords() {
                // テキスト検索の実行
                const inputEl = this.$refs.searchWords;
                const searchWords = inputEl.value;
                if (!this.marker) {
                    myVue.$data.marker = new Mark('.js-search');
                }
                myVue.$data.searchNoMatch = false;
                myVue.$data.marker.unmark();
                myVue.$data.marker.mark(searchWords, {
                    done() {
                        setTimeout(() => myVue.scrollToResult(), 200);
                    },
                    noMatch() {
                        myVue.$data.searchNoMatch = true;
                    },
                });
            },
            // 検索結果へのスクロール
            scrollToResult() {
                // 最新のキャラ一覧と、その他のキャラ一覧で検索対象を分ける
                let containerEl = this.$refs.latest;
                if (this.listType === this.listOther) {
                    containerEl = this.$refs.other;
                }
                containerEl = containerEl;
                this.scrollTo(containerEl.querySelector('mark'));
            },
        },
        mounted() {
            const scroller = scrollama();
            scroller
                .setup({
                step: '#js-header, #js-filter',
                offset: 0,
            })
                .onStepEnter((evt) => {
                if (evt.index === 0 && evt.direction === 'up') {
                    this.isShowScrollTop = false;
                }
            })
                .onStepExit((evt) => {
                if (evt.index === 1 && evt.direction === 'down') {
                    this.isShowScrollTop = true;
                }
            });
            this.charaList = charaList['ver7'];
            const selfEl = this.$root.$el;
            selfEl.style.opacity = '1';
        },
    });
});
